const Heading1 = ({ headingText }) => {
  return (
    <div className="flex flex-row items-center justify-start w-full pt-5 pb-2 select-none Xbg-red-500">
      <p className="text-4xl md:text-5xl font-medium">{headingText}</p>
    </div>
  );
};

const Heading2 = ({ headingText }) => {
  return (
    <div className="flex flex-row items-center justify-start w-full select-none Xbg-red-500">
      <p className="text-3xl font-medium">{headingText}</p>
    </div>
  );
};

const Heading3 = ({ headingText }) => {
  return (
    <div className="flex flex-row items-center justify-start w-full select-none Xbg-red-500">
      <p className="text-2xl font-medium">{headingText}</p>
    </div>
  );
};

export { Heading1, Heading2, Heading3 };
